import Conteiner from './Content'

export default Conteiner